{
  "version": "1.2.6",
  "objects": {
    "7452351310879316245": {
      "type": "frame",
      "id": "7452351310879316245",
      "z": 9439,
      "textContent": "",
      "left": 5594.547495930303,
      "top": -267.9606183456932,
      "width": 400,
      "height": 500,
      "scaleX": 1.464470524888993,
      "scaleY": 1.365027388597191,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452351310875126511": {
      "type": "frame",
      "id": "7452351310875126511",
      "z": 7978,
      "textContent": "<p>Card information</p>",
      "left": 5594.547495930303,
      "top": -267.9606183456932,
      "width": 400,
      "height": 500,
      "scaleX": 1.464470524888993,
      "scaleY": 0.5414236007184032,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310879316245",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452351310885819765": {
      "type": "frame",
      "id": "7452351310885819765",
      "z": 2975,
      "textContent": "Frame 14",
      "left": 5624.547495930303,
      "top": -67.25986076993564,
      "width": 400,
      "height": 500,
      "scaleX": 1.3144705248889932,
      "scaleY": 0.08002208556688811,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310875126511",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 30,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452351310876153597": {
      "type": "wireframe",
      "id": "7452351310876153597",
      "z": 7318,
      "top": -67.429528772153,
      "left": 5624.0606686954225,
      "width": 256.3070156382364,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310885819765",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Expiration date",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310885067005": {
      "type": "wireframe",
      "id": "7452351310885067005",
      "z": 7318,
      "top": -67.429528772153,
      "left": 5890.367684333659,
      "width": 258.4548487871216,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310885819765",
      "layoutPosition": "a1",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "CVV",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310878417059": {
      "type": "wireframe",
      "id": "7452351310878417059",
      "z": 7979,
      "top": -187.9606183456932,
      "left": 5624.827368271838,
      "width": 525.2284652725266,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310875126511",
      "layoutPosition": "ZzV",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Name ",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310886579282": {
      "type": "wireframe",
      "id": "7452351310886579282",
      "z": 7980,
      "top": -127.61023955781442,
      "left": 5624.830267364947,
      "width": 525.2226670863092,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310875126511",
      "layoutPosition": "Zzl",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Card number",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351445292704855": {
      "type": "frame",
      "id": "7452351445292704855",
      "z": 9449,
      "textContent": "Frame 46",
      "left": 5624.547495930303,
      "top": -237.9606183456932,
      "width": 400,
      "height": 500,
      "scaleX": 1.3144705248889932,
      "scaleY": 0.06,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310875126511",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7452351445308259836": {
      "type": "shape",
      "id": "7452351445308259836",
      "z": 7650,
      "shapeName": "text",
      "textContent": "<p><strong>Card information</strong></p>",
      "left": 5624.547495930303,
      "top": -237.9606183456932,
      "width": 165.39777800573574,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7452351445292704855",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": null,
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7452351310888087326": {
      "type": "frame",
      "id": "7452351310888087326",
      "z": 8452,
      "textContent": "<p>Billing address</p>",
      "left": 5594.547495930303,
      "top": 2.751182013508412,
      "width": 400,
      "height": 500,
      "scaleX": 1.464470524888993,
      "scaleY": 0.8236037878787879,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310879316245",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 20,
      "layoutPadding": 30,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7452351310889267200": {
      "type": "frame",
      "id": "7452351310889267200",
      "z": 2982,
      "textContent": "Frame 23",
      "left": 5624.547495930303,
      "top": 263.80231837714473,
      "width": 400,
      "height": 500,
      "scaleX": 1.3144705248889932,
      "scaleY": 0.08070075757575758,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310888087326",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a4",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452351310881949714": {
      "type": "wireframe",
      "id": "7452351310881949714",
      "z": 8544,
      "top": 263.80231837714473,
      "left": 5624.547495930303,
      "width": 254.72875192163337,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310889267200",
      "layoutPosition": "a0",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "State/Province",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310880943123": {
      "type": "wireframe",
      "id": "7452351310880943123",
      "z": 8554,
      "top": 263.80231837714473,
      "left": 5892.028690247664,
      "width": 256.3070156382364,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310889267200",
      "layoutPosition": "a1",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#333333",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Zip code",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310875768158": {
      "type": "frame",
      "id": "7452351310875768158",
      "z": 2983,
      "textContent": "Frame 22",
      "left": 5887.421600908101,
      "top": 384.50307595290235,
      "width": 400,
      "height": 500,
      "scaleX": 0.0001,
      "scaleY": 0.0001,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310888087326",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a6",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    },
    "7452351310874719998": {
      "type": "wireframe",
      "id": "7452351310874719998",
      "z": 6686,
      "top": 82.75118201350841,
      "left": 5625.014960383989,
      "width": 524.8532810482238,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310888087326",
      "layoutPosition": "a1",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Address line 1",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310886164703": {
      "type": "wireframe",
      "id": "7452351310886164703",
      "z": 6687,
      "top": 143.1015608013872,
      "left": 5624.889960383989,
      "width": 525.1032810482238,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310888087326",
      "layoutPosition": "a2",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Address line 2",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310879821596": {
      "type": "wireframe",
      "id": "7452351310879821596",
      "z": 6688,
      "top": 203.45193958926598,
      "left": 5624.889960383989,
      "width": 525.1032810482238,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310888087326",
      "layoutPosition": "a3",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "City",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351310880271101": {
      "type": "wireframe",
      "id": "7452351310880271101",
      "z": 7106,
      "top": 324.15269716502354,
      "left": 5624.889960383989,
      "width": 525.1032810482238,
      "height": 40.35037878787879,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7452351310888087326",
      "layoutPosition": "a5",
      "wireframeName": "inputField",
      "fill": "#CACACA",
      "textColor": "#3C3C3C",
      "style": "framed",
      "fontSize": 14,
      "label": { "value": "Password", "position": "noLabel" },
      "placeholder": {
        "state": "placeholder",
        "value": "Country",
        "iconLeft": null,
        "iconRight": null
      },
      "setDimension": true
    },
    "7452351500229704822": {
      "type": "frame",
      "id": "7452351500229704822",
      "z": 9459,
      "textContent": "Frame 46",
      "left": 5624.547495930303,
      "top": 32.75118201350841,
      "width": 400,
      "height": 500,
      "scaleX": 1.3144705248889932,
      "scaleY": 0.06,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7452351310888087326",
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7452351500233832878": {
      "type": "shape",
      "id": "7452351500233832878",
      "z": 7650,
      "shapeName": "text",
      "textContent": "<p><strong>Billing address</strong></p>",
      "left": 5624.547495930303,
      "top": 32.75118201350841,
      "width": 165.39777800573574,
      "height": 30,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1,
      "scaleY": 1,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 0.5,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 14,
      "angle": 0,
      "container": "7452351500229704822",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": null,
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
